export default __webpack_public_path__ + "static/media/Interior (4).b36b9eee.jpg";